import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss', '../platform.component.scss']
})
export class ContactComponent implements OnInit {

  mode:number = 0;
  constructor() { }

  ngOnInit(): void {
  }
  toggleContact(){
    
  }
  getManualSchool() {
    window.open("https://xxxxx.pdf")
  }
  getManualSupport() {
    window.open("https://xxxxx.pdf")
  }
}
